module.exports = __webpack_public_path__ + "static/media/rchic.f455fda9.png";